import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { Company, CompanyEnum } from '../../models/company.model';
import { Currency } from '../../models/currency.model';
import { PriceListNote } from '../../models/priceslist-note.model';
import { Note } from '../../models/types';
import { NotesService } from '../../services/notes.service';
import { NotesComponent } from '../notes/notes.component';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-camp-dates',
  imports: [TableModule, NgFor, DatePipe, NgIf, NotesComponent],
  templateUrl: './camp-dates.component.html',
  styleUrls: ['./camp-dates.component.scss', './print-camp-dates.scss'],
})
export class CampDatesComponent implements OnInit {
  @Input() company: Company = CompanyEnum.ALP;
  @Input() currency: Currency | undefined;
  @Input() startDates: string[];
  @Input() endDatesFlag: string | undefined;
  @Input() juniorDatesNotes: PriceListNote[] | undefined;
  notes: Note[] | undefined;

  private readonly notesService = inject(NotesService);

  ngOnInit(): void {
    const datesNotes = this.notesService.getNotes(this.juniorDatesNotes, this.endDatesFlag);
    if (datesNotes) {
      [this.notes] = datesNotes;
    }
  }
}
